// src/components/PageSeo.jsx
// Renders route-specific <head> tags using react-helmet-async.
// Accepts the object returned by getPageSeo() from src/utils/seoConfig.js.
//
// Usage:
//   import PageSeo from '../components/PageSeo';
//   import { getPageSeo } from '../utils/seoConfig';
//   ...
//   <PageSeo seo={getPageSeo('promotions', selectedState)} />

import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function PageSeo({ seo }) {
  if (!seo) return null;

  const {
    title,
    description,
    canonical,
    ogUrl,
    ogTitle,
    ogDescription,
    ogImage,
    twitterTitle,
    twitterDescription,
    robots,
  } = seo;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {robots && <meta name="robots" content={robots} />}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="BoostYourBets" />
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      {twitterTitle && <meta name="twitter:title" content={twitterTitle} />}
      {twitterDescription && <meta name="twitter:description" content={twitterDescription} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}
